/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_SessionsInputs */

const en_planner_sessions = /** @type {(inputs: Planner_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook sessions`)
};

const de_planner_sessions = /** @type {(inputs: Planner_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochsessions`)
};

/**
* | output |
* | --- |
* | "Cook sessions" |
*
* @param {Planner_SessionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_sessions = /** @type {((inputs?: Planner_SessionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_SessionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_sessions(inputs)
	return en_planner_sessions(inputs)
});